import PolicyDetailMobileDevice from './PolicyDetailMobileDevice';
export default PolicyDetailMobileDevice;